module.exports = __webpack_public_path__ + "img/house_17.5e9dedaa.jpg";